
export class TemplateProductLine {

  constructor(
    public code: string
  ) {}

}

